import { ItemBundleComponent } from '../../modules/bundles/item-bundle/item-bundle.component';
import { CollectionDocumentComponent } from '../../modules/collections/collection-document/collection-document.component';
import { CollectionOrganizationComponent } from '../../modules/collections/collection-organization/collection-organization.component';
import { ItemDocumentComponent } from '../../modules/items/item-document/item-document.component';
import { SecurityRoleOrganizationComponent } from '../../modules/security-roles/security-role-organization/security-role-organization.component';
import { SecurityRolePermissionComponent } from '../../modules/security-roles/security-role-permission/security-role-permission.component';

type EntityComponentType = { [key: string]: any };

let EntityComponent: EntityComponentType = {
  "CollectionOrganization": CollectionOrganizationComponent,
  "CollectionDocument": CollectionDocumentComponent,
  "ItemDocument": ItemDocumentComponent,
  "SecurityRoleOrganization": SecurityRoleOrganizationComponent,
  "SecurityRolePermission": SecurityRolePermissionComponent,
  "ItemBundle": ItemBundleComponent
}

export { EntityComponent };
